<template>
  <div
    id="checkInContainer"
    class="animated fadeIn"
  >
    <div class="container">
      <div class="row">
        <div class="col-12 pt-2 pb-3 pl-4">
          <h3>
            <i class="fas fa-map-marked-alt"></i> Módulo de Visitas
            <small style="font-size: 18px">| Registrar Check-in</small>
          </h3>
          <small>Acompanhe, planeje e registre suas visitas.</small>
        </div>
      </div>
      <div class="row pt-4 pb-3">
        <div class="col-12">
          <Forms
            ref="frmGroup"
            :title="'REGISTRAR CHECK-IN'"
            :showClearButton="true"
            :showSaveButton="true"
            :showBackButton="true"
            v-on:Clear="onClear"
            v-on:Back="onBack"
            v-on:Save="onSave"
          >
            <div class="form-group row">
              <div class="col-md-12">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.documento.required"
                  >
                    *
                  </small>
                  CPF/CNPJ:
                </label>
                <div class="input-group">
                  <b-form-input
                    autofocus
                    type="text"
                    ref="documento"
                    :placeholder="'Digite o CPF ou CNPJ do Contato'"
                    v-model="form.documento.value"
                    :size="form.documento.maxlength"
                    :required="form.documento.required"
                    :state="form.documento.state"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                    @blur="onSearchPessoa"
                    :disabled="naoDesejaInformarDocumento"
                  ></b-form-input>
                  <span
                    class="input-group-addon"
                    @click="onSearchPessoa"
                  >
                    <i class="fa fa-search"></i>
                  </span>
                </div>
                <b-form-checkbox
                  class="pt-2"
                  v-model="naoDesejaInformarDocumento"
                  :value="true"
                  :unchecked-value="false"
                >
                  Não informar CPF/CNPJ
                </b-form-checkbox>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-12">
                <label>
                  <small
                    class="text-danger"
                    v-if="form.nome.required"
                  >
                    *
                  </small>
                  Nome:
                </label>
                <div class="input-group flex-nowrap">
                  <span class="input-group-addon">
                    <i class="fa fa-user"></i>
                  </span>
                  <v-select
                    label="text"
                    v-if="!filledDocument"
                    @input="onLoadLeads"
                    @search="onLoadLeads"
                    v-model="form.nome.selected"
                    :options="form.nome.listOptions"
                    :placeholder="'Digite o Nome do Contato'"
                    :required="form.nome.required"
                    :state="form.nome.state"
                  >
                    <template v-slot:no-options>
                      Nenhum lead encontrado.
                    </template>
                  </v-select>
                  <b-form-input
                    v-if="filledDocument"
                    type="text"
                    :placeholder="'Digite o Nome do Contato'"
                    v-model="form.nome.value"
                    :required="form.nome.required"
                    :state="form.nome.state"
                  ></b-form-input>
                </div>
              </div>
            </div>
            <div
              v-if="!alreadyPerson"
              class="form-group row pt-2"
            >
              <div class="col-md-6">
                <label
                  ><small
                    class="text-danger"
                    v-if="form.telefone.required"
                  >
                    *
                  </small>
                  Telefone:
                </label>
                <div class="input-group">
                  <span class="input-group-addon"
                    ><i class="fas fa-phone-alt"></i
                  ></span>
                  <b-form-input
                    type="text"
                    :placeholder="'Digite o Telefone do Contato'"
                    v-model="form.telefone.value"
                    :size="form.telefone.maxlength"
                    :required="form.telefone.required"
                    :state="form.telefone.state"
                    v-mask="['(##) ####-####']"
                  ></b-form-input>
                </div>
              </div>

              <div class="col-md-6">
                <label
                  ><small
                    class="text-danger"
                    v-if="form.celular.required"
                  >
                    *
                  </small>
                  Celular:
                </label>
                <div class="input-group">
                  <span class="input-group-addon"
                    ><i class="fas fa-mobile"></i
                  ></span>
                  <b-form-input
                    type="text"
                    :placeholder="'Digite o Telefone do Contato'"
                    v-model="form.celular.value"
                    :size="form.celular.maxlength"
                    :required="form.celular.required"
                    :state="form.celular.state"
                    v-mask="['(##) # ####-####']"
                  ></b-form-input>
                </div>
              </div>
            </div>
            <div class="form-group row pt-2">
              <div class="col-md-12">
                <label><small class="text-danger">*</small> Local:</label>
                <div
                  class="input-group"
                  style="border: solid 1px #d6d6d6"
                >
                  <Map
                    v-if="data.deslocamentoId !== null"
                    ref="map"
                    style="width: 100%; height: 400px"
                    @initialized="onInitialized"
                    @change:location="handleCoords"
                  />
                </div>
              </div>
            </div>
          </Forms>
        </div>
      </div>
      <div class="row mt-5 pt-5">
        <div class="col-12 text-center">
          <img
            src="/static/img/bg/world_re_768g.svg"
            style="width: 40%; opacity: 0.2"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import PersonRepository from '@/shared/http/repositories/configurations/person.js'
import DeslocamentoRepository from '@/shared/http/repositories/deslocamento/deslocamento.js'

import Map from '../../components/Map.vue'

const form = {
  documento: {
    value: '',
    maxlength: '30',
    required: true,
    state: null
  },
  nome: {
    value: null,
    listOptions: [],
    selected: null,
    required: true,
    state: null
  },
  telefone: {
    value: null,
    maxlength: '10',
    required: false,
    state: null
  },
  celular: {
    value: null,
    maxlength: '11',
    required: false,
    state: null
  },
  personId: {
    value: null,
    required: false,
    state: null
  }
}
const data = {
  personId: null,
  deslocamentoId: null,
  latitudeInicial: null,
  longitudeInicial: null,
  kmRodado: null,
  coordsTempoReal: null,
  documento: null,
  nome: null,
  telefone: null,
  celular: null
}

export default {
  name: 'Checkin',
  mixins: [ActionsForm],
  components: { Map },
  data () {
    return {
      data: data,
      form: form,
      alreadyPerson: false,
      filledDocument: false,
      searchingByName: false,
      nameNotPerson: '',
      naoDesejaInformarDocumento: false
    }
  },
  async mounted () {
    loading.push()
    Tools.MinimizedSidebar()
    await this.getDeslocamento()
  },
  watch: {
    naoDesejaInformarDocumento (newValue) {
      if (newValue) {
        this.form.documento.document = null
        toast.info(
          'Você optou por não informar o documento, para prosseguir com a abertura da oportunidade sem o CPF/CNPJ insira o nome, celular ou telefone.'
        )
      }

      this.form.documento.required = !newValue
    }
  },
  methods: {
    onBack () {
      this.$router.push({ name: 'Visitas' })
    },
    onInitialized () {
      loading.pop()
    },
    async handleCoords () {
      const currentCoords = await this.$refs.map.getCurrentLocation()
      const kmRodado = await this.getKmRodado(currentCoords)

      this.data.coordsTempoReal = this.data.coordsTempoReal === null
      this.data.latitudeInicial = currentCoords.latitude
      this.data.longitudeInicial = currentCoords.longitude
      this.data.kmRodado = kmRodado
    },
    async getDeslocamento () {
      const response = await DeslocamentoRepository.GetActive()

      if (response.data === '') {
        this.onBack()
        return
      }

      this.data.deslocamentoId = response.data.id
    },
    async getKmRodado (currentCoords) {
      const { data } = await DeslocamentoRepository.GetCoordinates(
        this.data.deslocamentoId
      )

      const origin = {
        latitude: data.latitude,
        longitude: data.longitude
      }

      const destination = {
        latitude: currentCoords.latitude,
        longitude: currentCoords.longitude
      }

      const response = await this.$refs.map.getDistance(origin, destination)

      if (!response) {
        toast.error(
          'Não foi possível calcular a distância percorrida. Tente Novamente'
        )
        return
      }

      return response.distance.value
    },
    setFormValues (dataToForm) {
      this.form.documento.value = dataToForm.document
      this.form.nome.selected = dataToForm.nome
      this.form.nome.value = dataToForm.nome
    },
    async onCreate () {
      if (this.data.latitudeInicial === null) {
        toast.error('Geolocalização é necessária para iniciar o deslocamento')
        return
      }

      if (this.data.deslocamentoId === null) {
        toast.error('Não há um deslocamento em andamento para fazer check-in')
        return
      }

      if (!this.data.kmRodado) {
        toast.error('Não foi possível calcular a distância percorrida.')
        return
      }

      if (
        !this.alreadyPerson &&
        !this.data.documento &&
        !this.data.telefone &&
        !this.data.celular
      ) {
        toast.error(
          'Informe ao menos um telefone/celular para realizar o check-in'
        )
        return
      }

      if (this.alreadyPerson && !this.data.documento) {
        toast.error('Informe CPF/CNPJ para realizar o check-in')
        return
      }

      if (this.data.documento) {
        this.data.documento = this.data.documento.replace(/[^\d]+/g, '')
      }

      try {
        loading.push()

        if (this.alreadyPerson) {
          this.data.telefone = null
          this.data.celular = null

          await DeslocamentoRepository.CheckIn(this.data)
        } else {
          await DeslocamentoRepository.CheckInAndCreatePerson(this.data)
        }

        toast.success(this.$lang.Common.Alerts.Success)
        this.onBack()
      } catch (error) {
        toast.error(this.$lang.Common.Alerts.Error)
      } finally {
        loading.pop()
      }
    },
    onSearchPessoa () {
      if (this.form.documento.value || this.form.nome.selected) {
        if (this.form.documento.value) this.filledDocument = true
        this.personDocument = this.searchingByName
          ? this.form.nome.selected.value
          : this.form.documento.value.replace(/[^\d]+/g, '')

        if (this.form.documento.value && this.form.nome.value) return

        this.getPersonData(this.personDocument)
      } else {
        this.clearForms()
        toast.info(
          'Atenção! Você precisa informar um CPF ou CNPJ para localizar o contato.',
          'Nova Oportunidade'
        )
      }
    },
    onLoadLeads (search) {
      this.manageNameComponent(search)
      if (this.form.nome.selected && !search) {
        this.form.nome.value = this.form.nome.selected.text

        this.searchingByName = true
        this.onSearchPessoa(search.value)
        this.searchingByName = false
      } else if (typeof search === 'string') {
        PersonRepository.GetByName(search).then((response) => {
          this.form.nome.listOptions = response.data.content
            .filter((x) => x.id != null)
            .map((x) => ({ value: x.document, text: x.nome }))
        })
      }
    },
    manageNameComponent (search) {
      if (search !== '') {
        this.nameNotPerson = search
        return
      }

      if (!this.form.nome.selected) {
        this.filledDocument = true
        this.form.nome.value = this.nameNotPerson
        toast.info(
          'Não foi encontrado uma pessoa com este Nome.',
          'Nova Oportunidade'
        )
        // this.$refs.documento.focus()
      }
    },
    clearForms () {
      this.alreadyPerson = false
      this.filledDocument = false
      this.form.documento.value = null
      this.form.nome.value = null
      this.form.nome.selected = null
      this.form.personId.value = null

      this.data.personId = null
      this.data.documento = null
      this.data.nome = null
      this.data.personId = null
    },
    getPersonData (documentOnlyNumber) {
      PersonRepository.GetByDocument(documentOnlyNumber)
        .then((response) => {
          let data = response.data.content

          if (data.length > 0 && documentOnlyNumber) {
            this.form.personId.value = data[0].id
            this.alreadyPerson = true
            this.$nextTick(async () => {
              await this.setFormValues(response.data.content[0])
              this.$forceUpdate()
            })
          } else {
            this.alreadyPerson = false
            if (!this.form.nome.value) {
              toast.info(
                'Não foi encontrado uma pessoa com este CPF.',
                'Nova Oportunidade'
              )
            }
          }
        })
        .catch((err) => {
          console.error('err', err)
          this.onException(err)
        })
    }
  }
}
</script>

<style scoped>
.card {
  border-radius: 11px;
  box-shadow: 0 0 1em #ccc;
}
h4 {
  font-size: 1.25rem !important;
  font-weight: bold;
}
.pointer {
  cursor: pointer;
}
</style>

<style lang="scss">
#checkInContainer {
  .v-select {
    flex: 1 1 auto;
    background: #fff
      url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
      no-repeat right 0.75rem center;
    background-size: 8px 10px;
  }

  .v-select input {
    padding: 2px 1rem;
    font-size: 13px;
    line-height: 1.25;
    background-clip: padding-box;
    color: #b0bec5;
  }

  .vs__selected-options {
    color: #607d8b;
  }

  .v-select > #vs1__combobox {
    height: 35px;
    border-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/visitas/deslocamento/register/checkin.vue